import React, { useState, useMemo, useEffect } from 'react';
import { Input, Avatar } from 'antd';
import { ContactImage } from '../../Common/Icons';
import { getCurrentUser } from '@vantiva-sa/homesight_humaui/Store/authStore';
import { useSelector } from 'react-redux';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';
import { getUsername } from '@vantiva-sa/homesight_humaui/Utilities/CommonUtilities';
import { PhotoResolution } from '@vantiva-sa/homesight_humaui/Utilities/Constants';

const AddStaff = ({ staffListData = [], selectedStaff = [], onStaffSelect, onStaffDeselect }) => {
  const trans = useSelector(translator);
  const currentUser = useSelector(getCurrentUser);

  const displayStaffList = useMemo(() => {
    // Ensure we have valid data
    if (!staffListData || !Array.isArray(staffListData)) {
      console.warn('staffListData is not a valid array:', staffListData);
      return [];
    }
    return staffListData;
  }, [staffListData, currentUser]);

  const [searchText, setSearchText] = useState('');

  // Handle search functionality
  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const handleClearSearch = () => {
    setSearchText('');
  };

  // Filter staff based on search
  const filteredStaff = useMemo(() => {
    if (!searchText || !searchText.trim()) {
      return displayStaffList;
    }

    const searchTerm = searchText.toLowerCase();
    return displayStaffList.filter((staff) => {
      const username = getUsername(staff)?.toLowerCase() || '';
      const email = (staff.email || '').toLowerCase();
      const role = (staff.permission_level || staff.rolename || '').toLowerCase();
      const staffRole = (staff.staffrole || '').toLowerCase();

      return (
        username.includes(searchTerm) ||
        email.includes(searchTerm) ||
        role.includes(searchTerm) ||
        staffRole.includes(searchTerm)
      );
    });
  }, [displayStaffList, searchText]);

  // Handle staff selection toggle (click to select like AddAccount)
  const handleStaffClick = (staff) => {
    const isSelected = isStaffSelected(staff);
    if (isSelected) {
      onStaffDeselect && onStaffDeselect(staff);
    } else {
      onStaffSelect && onStaffSelect(staff);
    }
  };

  // Check if staff is selected
  const isStaffSelected = (staff) => {
    return selectedStaff.some((selected) => selected.useruuid === staff.useruuid);
  };

  return (
    <div className="add-member-container">
      {/* Search Section */}
      <div className="search-section">
        <Input
          className="search-input"
          value={searchText}
          onChange={handleSearchChange}
          placeholder={trans('SEARCH')}
          allowClear
        />
      </div>

      {/* Staff List */}
      <div className="members-list-container">
        {filteredStaff.length > 0 ? (
          filteredStaff.map((staff, index) => (
            <div
              key={`staff-${staff.useruuid}-${index}`}
              className={`member-item ${isStaffSelected(staff) ? 'selected' : ''}`}
              onClick={() => handleStaffClick(staff)}
            >
              <Avatar
                size={60}
                src={staff.profilePics?.[PhotoResolution.R64]}
                icon={staff.profilePics?.[PhotoResolution.R64] ? null : <ContactImage />}
                className="member-avatar"
              />
              <div className="member-name staff-member-name">
                {getUsername(staff) || trans('UNKNOWNSTAFF')}
              </div>
            </div>
          ))
        ) : (
          <div className="no-members-container">
            <div className="no-members-message">
              {searchText ? trans('NOSTAFFFOUNDMATCHINGYOURSERACH') : trans('NOSTAFFAVAILABLE')}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AddStaff;
